// /coaches/text: the batch Text flow for the coaches ticked on the list (location.state.ids).
// location.state.kind says which list launched it ('high_school' or college), so the rail and the
// way back match. Landing here with nothing selected (a reload, a typed URL) goes back to the list.
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AdminSidebar } from '../components/AdminShell';
import TextFlow from '../components/crm/TextFlow';
import './AdminDashboard.css';
import '../components/AdminShell.css';
import './CoachesPage.css';

export default function TextFlowPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const ids = location.state?.ids;
  const isHs = location.state?.kind === 'high_school';
  const list = isHs ? '/coaches/high-school' : '/coaches';
  if (!Array.isArray(ids) || ids.length === 0) return <Navigate to={list} replace />;
  return (
    <div className="adm">
      <div className="adm__shell">
        <AdminSidebar active={isHs ? 'hs-coaches' : 'coaches'} />
        <main className="adm__main">
          <div className="adm__card cr-section">
            <TextFlow ids={ids} onDone={() => navigate(list)} />
          </div>
        </main>
      </div>
    </div>
  );
}
